export const EDITABLE_INPUT_ID = 'editable-message-text' as const;
export const EDITABLE_INPUT_MODAL_ID = 'editable-message-text-modal' as const;
export const EDITABLE_INPUT_CSS_SELECTOR = `.messages-layout #${EDITABLE_INPUT_ID}` as const;
